const afterPeriodFilter = (el, val, filterCol) => {
    // if value is null return true (no comparison)
    if (val == null){
        return true; 
    }
    // tempDate for selecting first day of month of val
    let tempDate = new Date(val.valueOf()); 
    tempDate.setDate(1); 
    tempDate.setHours(0); 
    tempDate.setMinutes(0); 
    tempDate.setSeconds(0); 
    tempDate.setMilliseconds(0); 
    // parse periodid from column into date
    let date; 
    if (el[filterCol]){
        date = new Date(
            parseInt(el[filterCol].toString().substring(0, 4)), 
            parseInt(el[filterCol].toString().substring(4, 6)) - 1, 
            1, 
            0, 
            0, 
            0,
            0,
        ); 
    }
    else {
        return true; 
    }
    // return true if val is date after column
    return tempDate.valueOf() <= date.valueOf(); 
}

export default afterPeriodFilter; 